import { render } from "./GeneralContentSkeleton.vue?vue&type=template&id=2e3f0836"
const script = {}

import "./GeneralContentSkeleton.vue?vue&type=style&index=0&id=2e3f0836&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-iframe-br/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__